import { RootAppState } from 'store/configureStore'
import { bomItemMaterialSummarySelector } from './bomItemMaterialSummarySelector'

export const bomItemPriceSummarySelector =
  (bomItemId: string) => (state: RootAppState) => {
    const materialSummary = bomItemMaterialSummarySelector(bomItemId)(state)

    return state.project.priceSummaries[materialSummary.id]
  }
